import script from "./Excalibur.vue?vue&type=script&setup=true&lang=ts"
export * from "./Excalibur.vue?vue&type=script&setup=true&lang=ts"

import "./Excalibur.vue?vue&type=style&index=0&id=27781386&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27781386"]])

export default __exports__